// extracted by mini-css-extract-plugin
module.exports = {"suggestedList":"SuggestedResultList_suggestedList__fgg1Q"};